import "./App.css";
import Quotes from "./pages/Quotes";
import QuoteDetail from "./pages/QuoteDetail";
import PartHistory from "./pages/PartHistory";
import Invoices from "./pages/Invoices";
import CustomersEnhanced from "./pages/CustomersEnhanced";
import Suppliers from "./pages/Suppliers";
import PurchaseOrders from "./pages/PurchaseOrders";
import RFQs from "./pages/RFQs";
import JobSheets from "./pages/JobSheets";
import ShopFloorEntry from "./pages/ShopFloorEntry";
import ProductionDashboard from "./pages/ProductionDashboard";
import OverdueJobs from "./pages/OverdueJobs";
import Scheduling from "./pages/Scheduling";
import GanttScheduler from "./pages/GanttScheduler";
import TimeClock from "./pages/TimeClock";
import EfficiencyReports from "./pages/EfficiencyReports";
import PackingSlips from "./pages/PackingSlips";
import Inventory from "./pages/Inventory";
import GeneralInventory from "./pages/GeneralInventory";
import StocktakeCount from "./pages/StocktakeCount";
import ISOAudits from "./pages/ISOAudits";
import AuditReportDetail from "./pages/AuditReportDetail";
import CalibrationSchedule from "./pages/CalibrationSchedule";
import CalibrationRecord from "./pages/CalibrationRecord";
import ElectricityUsage from "./pages/ElectricityUsage";
import RecycledMetal from "./pages/RecycledMetal";
import LegalRequirements from "./pages/LegalRequirements";
import SupplierReviews from "./pages/SupplierReviews";
import EnvironmentalRiskAssessment from "./pages/EnvironmentalRiskAssessment";
import MSDSRegister from "./pages/MSDSRegister";
import EvacuationDrills from "./pages/EvacuationDrills";
import TrainingMatrix from "./pages/TrainingMatrix";
import DocumentControl from "./pages/DocumentControl";
import CustomerSatisfaction from "./pages/CustomerSatisfaction";
import FormsLibrary from "./pages/FormsLibrary";
import EmploymentApplicationForm from "./pages/EmploymentApplicationForm";
import EmploymentApplicationSubmissions from "./pages/EmploymentApplicationSubmissions";
import InjuryRegister from "./pages/InjuryRegister";
import InjuryRegisterForm from "./pages/InjuryRegisterForm";
import InjuryGraph from "./pages/InjuryGraph";
import CourierKPI from "./pages/CourierKPI";
import AuditSchedule from "./pages/AuditSchedule";
import StandardsLibrary from "./pages/StandardsLibrary";
import AuditTemplates from "./pages/AuditTemplates";
import AssetRegisters from "./pages/AssetRegisters";
import AuditDashboard from "./pages/AuditDashboard";
import IMSManual from "./pages/IMSManual";
import Policies from "./pages/Policies";
import NCRRegister from "./pages/NCRRegister";
import NCRForm from "./pages/NCRForm";
import CreditRequestsLog from "./pages/CreditRequestsLog";
import ForkliftRegister from "./pages/ForkliftRegister";
import FirstAidRegister from "./pages/FirstAidRegister";
import ManagementReview from "./pages/ManagementReview";
import ManagementReviewForm from "./pages/ManagementReviewForm";
import OHSMeetings from "./pages/OHSMeetings";
import OHSMeetingForm from "./pages/OHSMeetingForm";
import { HousekeepingAudits, HousekeepingAuditForm } from "./pages/HousekeepingAudits";
import JSARegister from "./pages/JSARegister";
import JSAForm from "./pages/JSAForm";
import JSADetail from "./pages/JSADetail";
import PlantHazardChecks from "./pages/PlantHazardChecks";
import NearMissRegister from "./pages/NearMissRegister";
import TrainingAppraisal from "./pages/TrainingAppraisal";
import RiskOpportunities from "./pages/RiskOpportunities";
import Employees from "./pages/Employees";
import ClockInOut from "./pages/ClockInOut";
import LeaveManagement from "./pages/LeaveManagement";
import LeaveOfAbsence from "./pages/LeaveOfAbsence";
import NxSettings from "./pages/Settings";
import MenuConfig from "./pages/MenuConfig";
import DataMigration from "./pages/DataMigration";
import SupplierDashboard from "./pages/SupplierDashboard";
import Dashboard from "./pages/Dashboard";
export { Dashboard as NxDashboard };

export const ERP_ROUTES = [
  ["/quotes", Quotes], ["/quotes/:id", QuoteDetail], ["/part-history", PartHistory], ["/invoices", Invoices],
  ["/customers", CustomersEnhanced], ["/suppliers", Suppliers], ["/purchase-orders", PurchaseOrders], ["/rfqs", RFQs],
  ["/jobsheets", JobSheets], ["/job-sheets", JobSheets], ["/shop-floor", ShopFloorEntry], ["/production-dashboard", ProductionDashboard],
  ["/overdue-jobs", OverdueJobs], ["/scheduling", Scheduling], ["/gantt-scheduler", GanttScheduler], ["/time-clock", TimeClock],
  ["/efficiency-reports", EfficiencyReports], ["/packing-slips", PackingSlips], ["/inventory", Inventory], ["/general-inventory", GeneralInventory], ["/stocktake-count/:id", StocktakeCount],
  ["/ims/manual", IMSManual], ["/quality/audit-dashboard", AuditDashboard], ["/quality/standards-library", StandardsLibrary],
  ["/quality/legal-requirements", LegalRequirements], ["/quality/audits", ISOAudits], ["/quality/audits/:id", AuditReportDetail],
  ["/quality/audit-schedule", AuditSchedule], ["/quality/audit-templates", AuditTemplates],
  ["/quality/management-review", ManagementReview], ["/quality/management-review/new", ManagementReviewForm], ["/quality/management-review/:id", ManagementReviewForm],
  ["/quality/document-control", DocumentControl], ["/quality/policies", Policies], ["/quality/forms", FormsLibrary],
  ["/quality/forms/employment-application", EmploymentApplicationForm], ["/quality/forms/employment-application/submissions", EmploymentApplicationSubmissions],
  ["/ims/risk-opportunities", RiskOpportunities], ["/quality/ncr", NCRRegister], ["/quality/ncr/new", NCRForm], ["/quality/ncr/:id", NCRForm],
  ["/quality/credit-requests", CreditRequestsLog], ["/quality/supplier-reviews", SupplierReviews], ["/quality/customer-satisfaction", CustomerSatisfaction],
  ["/quality/jsa", JSARegister], ["/jsa/new", JSAForm], ["/jsa/:id", JSADetail], ["/jsa/:id/edit", JSAForm],
  ["/safety/plant-hazard-checks", PlantHazardChecks], ["/safety/near-miss", NearMissRegister],
  ["/safety/injury-register", InjuryRegister], ["/safety/injury-register/new", InjuryRegisterForm], ["/safety/injury-register/:id", InjuryRegisterForm],
  ["/safety/injury-graph", InjuryGraph], ["/safety/ohs-meetings", OHSMeetings], ["/safety/ohs-meetings/new", OHSMeetingForm], ["/safety/ohs-meetings/:id", OHSMeetingForm],
  ["/safety/training-appraisals", TrainingAppraisal], ["/safety/training-matrix", TrainingMatrix],
  ["/safety/forklift-register", ForkliftRegister], ["/safety/first-aid-register", FirstAidRegister], ["/quality/evacuation", EvacuationDrills],
  ["/safety/housekeeping-audits", HousekeepingAudits], ["/safety/housekeeping-audits/new", HousekeepingAuditForm], ["/safety/housekeeping-audits/:id", HousekeepingAuditForm],
  ["/quality/environmental-risk", EnvironmentalRiskAssessment], ["/quality/electricity", ElectricityUsage], ["/quality/recycled-metal", RecycledMetal],
  ["/quality/msds", MSDSRegister], ["/quality/calibration", CalibrationSchedule], ["/quality/calibration/record/new", CalibrationRecord],
  ["/quality/asset-registers", AssetRegisters], ["/operations/courier-kpi", CourierKPI],
  ["/employees", Employees], ["/clock-in-out", ClockInOut], ["/leave-management", LeaveManagement], ["/hr/leave-of-absence", LeaveOfAbsence],
  ["/settings", NxSettings], ["/settings/menu", MenuConfig], ["/data-migration", DataMigration], ["/supplier-dashboard", SupplierDashboard],
  ["/dashboard", Dashboard],
];
